// Copyright 1999-2019. Plesk International GmbH. All rights reserved.

import { render, createElement, Alert } from '@plesk/ui-library';
import { Locale } from '../../jsw/locale';
import ClosableAlert from './closable-alert';

const TYPE_SEND_ANNOUNCE = 'send_announce';
const TYPE_SEND_PERSONALIZED_ANNOUNCE = 'send_personalized_announce';
const TYPE_NONE = 'none';

export default ({ id, getConsentUrl, closeConsentInfoUrl, email, infoClosed, dialogShown, locale }) => {
    locale = new Locale(locale);
    const loaderBlock = document.getElementById(`${id}-loader`);
    const input = document.getElementById(`${id}`);
    const infoBlock = document.getElementById(`${id}-info`);
    const checkbox = document.getElementById(`${id}-checkbox`);
    const checkboxBlock = document.getElementById(`${id}-checkbox-block`);
    const radioBlock = document.getElementById(`${id}-radio-block`);
    const warningBlock = document.getElementById(`${id}-warning`);
    const retryButton = document.getElementById(`${id}-retry`);

    const hasPersonalizedConsent = consents => consents.some(consent => consent.type === TYPE_SEND_PERSONALIZED_ANNOUNCE);

    const showInfoMsg = consents => {
        if (hasPersonalizedConsent(consents)) {
            return;
        }

        if (consents.length > 0) {
            !infoClosed && render(
                <ClosableAlert onClose={() => new Ajax.Request(closeConsentInfoUrl, { method: 'post' })}>
                    {locale.lmsg('consentGivenInfo')}
                </ClosableAlert>,
                infoBlock
            );
        } else if (dialogShown) {
            render(
                <Alert intent="info">
                    {locale.lmsg('consentNotGivenInfo')}
                </Alert>,
                infoBlock
            );
        }
    };

    const showConsent = consents => {
        if (hasPersonalizedConsent(consents)) {
            checkbox.checked = true;
            checkboxBlock.style.display = '';
            input.value = TYPE_SEND_PERSONALIZED_ANNOUNCE;
            checkbox.addEventListener('change', e => {
                input.value = e.target.checked ? TYPE_SEND_PERSONALIZED_ANNOUNCE : TYPE_NONE;
            });
        } else if (consents.length > 0) {
            radioBlock.style.display = '';
            input.value = TYPE_SEND_ANNOUNCE;
            radioBlock.addEventListener('change', e => {
                input.value = e.target.value;
            });
        } else {
            checkbox.checked = false;
            checkboxBlock.style.display = '';
            input.value = TYPE_NONE;
            checkbox.addEventListener('change', e => {
                input.value = e.target.checked ? TYPE_SEND_PERSONALIZED_ANNOUNCE : TYPE_NONE;
            });
        }
    };

    const loadConsentStatus = () => {
        checkboxBlock.style.display = 'none';
        radioBlock.style.display = 'none';
        warningBlock.style.display = 'none';
        loaderBlock.style.display = '';

        new Ajax.Request(getConsentUrl, {
            method: 'get',
            parameters: { email },
            onSuccess: transport => {
                const response = JSON.parse(transport.responseText);
                loaderBlock.style.display = 'none';

                if (response.status === 'error' || !response.consents) {
                    warningBlock.style.display = '';
                } else {
                    const consents = response.consents.filter(consent => consent.enabled);
                    showInfoMsg(consents);
                    showConsent(consents);
                }
            },
            onFailure: () => {
                loaderBlock.style.display = 'none';
                warningBlock.style.display = '';
            },
        });
    };

    retryButton.addEventListener('click', e => {
        e.preventDefault();
        loadConsentStatus();
    });

    loadConsentStatus();
};



// WEBPACK FOOTER //
// ./app/profile/announcement-settings.js